//import React from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";


const VerifyRestaurant = () => {

  const [searchParams] = useSearchParams();

    useEffect(() => {
        checkrestau();
    }, []);

    const checkrestau = () => {
    const stored = localStorage.getItem("cuisinier_actif");
    const idParam = searchParams.get("id_restaurant");
      if (!stored || stored === "undefined" || stored === "null" || stored.trim() === "") {
      return;
    }

    let cuisinierActif;
    if (stored) {
      try {
        cuisinierActif = JSON.parse(stored);
      } catch (e) {
        console.error("Erreur de parsing JSON :", e);
      }
    }
    
    if (!cuisinierActif || !cuisinierActif?.id_restaurant) {
      return;
    }
    // si pas de param, on ne force pas la déconnexion
    if (!idParam) return;

      if (String(idParam) !== String(cuisinierActif?.id_restaurant)) {
        localStorage.removeItem("cuisinier_actif");
        window.location.reload();
      }
    };

  return null;
}

export default VerifyRestaurant;